/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Releases_Monthlytitle1Inputs */

const id_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis bulanan`)
};

const ms_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluaran bulanan`)
};

const da_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlige udgivelser`)
};

const de_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliche Veröffentlichungen`)
};

const en_us2_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly releases`)
};

const es_es2_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzamientos mensuales`)
};

const es_mx2_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzamientos mensuales`)
};

const fil_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buwanang release`)
};

const fr_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorties mensuelles`)
};

const it_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uscite mensili`)
};

const hu_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havi megjelenések`)
};

const nl_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijkse releases`)
};

const no_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlige utgivelser`)
};

const pl_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydania miesięczne`)
};

const pt_br2_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançamentos mensais`)
};

const pt_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançamentos mensais`)
};

const ro_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansări lunare`)
};

const fi_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuukausittaiset julkaisut`)
};

const sv_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månatliga släpp`)
};

const vi_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát hành hàng tháng`)
};

const tr_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık çıkışlar`)
};

const cs_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíční vydání`)
};

const bg_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месечни издавания`)
};

const ru_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячные релизы`)
};

const uk_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щомісячні релізи`)
};

const ar_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإصدارات الشهرية`)
};

const hi_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मासिक रिलीज़`)
};

const th_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การวางจำหน่ายรายเดือน`)
};

const ja_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月別リリース数`)
};

const zh_cn2_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月发布`)
};

const zh_hant1_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月發布`)
};

const ko_stats_releases_monthlytitle1 = /** @type {(inputs: Stats_Releases_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월별 출시`)
};

/**
* | output |
* | --- |
* | "Monthly releases" |
*
* @param {Stats_Releases_Monthlytitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_releases_monthlytitle1 = /** @type {((inputs?: Stats_Releases_Monthlytitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Releases_Monthlytitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_releases_monthlytitle1(inputs)
	if (locale === "ms") return ms_stats_releases_monthlytitle1(inputs)
	if (locale === "da") return da_stats_releases_monthlytitle1(inputs)
	if (locale === "de") return de_stats_releases_monthlytitle1(inputs)
	if (locale === "en-US") return en_us2_stats_releases_monthlytitle1(inputs)
	if (locale === "es-ES") return es_es2_stats_releases_monthlytitle1(inputs)
	if (locale === "es-MX") return es_mx2_stats_releases_monthlytitle1(inputs)
	if (locale === "fil") return fil_stats_releases_monthlytitle1(inputs)
	if (locale === "fr") return fr_stats_releases_monthlytitle1(inputs)
	if (locale === "it") return it_stats_releases_monthlytitle1(inputs)
	if (locale === "hu") return hu_stats_releases_monthlytitle1(inputs)
	if (locale === "nl") return nl_stats_releases_monthlytitle1(inputs)
	if (locale === "no") return no_stats_releases_monthlytitle1(inputs)
	if (locale === "pl") return pl_stats_releases_monthlytitle1(inputs)
	if (locale === "pt-BR") return pt_br2_stats_releases_monthlytitle1(inputs)
	if (locale === "pt") return pt_stats_releases_monthlytitle1(inputs)
	if (locale === "ro") return ro_stats_releases_monthlytitle1(inputs)
	if (locale === "fi") return fi_stats_releases_monthlytitle1(inputs)
	if (locale === "sv") return sv_stats_releases_monthlytitle1(inputs)
	if (locale === "vi") return vi_stats_releases_monthlytitle1(inputs)
	if (locale === "tr") return tr_stats_releases_monthlytitle1(inputs)
	if (locale === "cs") return cs_stats_releases_monthlytitle1(inputs)
	if (locale === "bg") return bg_stats_releases_monthlytitle1(inputs)
	if (locale === "ru") return ru_stats_releases_monthlytitle1(inputs)
	if (locale === "uk") return uk_stats_releases_monthlytitle1(inputs)
	if (locale === "ar") return ar_stats_releases_monthlytitle1(inputs)
	if (locale === "hi") return hi_stats_releases_monthlytitle1(inputs)
	if (locale === "th") return th_stats_releases_monthlytitle1(inputs)
	if (locale === "ja") return ja_stats_releases_monthlytitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_releases_monthlytitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_releases_monthlytitle1(inputs)
	return ko_stats_releases_monthlytitle1(inputs)
});
export { stats_releases_monthlytitle1 as "stats.releases.monthlyTitle" }